import { create } from 'zustand'

type ReferenceMap = Record<string, number>

type ReferenceMapsState = {
  assignReferenceIndex: (messageId: string, referenceId: string) => number
  getReferenceMapByMessageId: (messageId: string) => ReferenceMap
  referenceMaps: Record<string, ReferenceMap>
}

const initialState: Pick<ReferenceMapsState, 'referenceMaps'> = {
  referenceMaps: {},
}

const useReferenceMaps = create<ReferenceMapsState>((set, get) => ({
  ...initialState,
  assignReferenceIndex: (messageId: string, referenceId: string) => {
    let referenceMap = get().referenceMaps[messageId]

    if (!referenceMap) {
      referenceMap = {}
      set(state => ({
        referenceMaps: {
          ...state.referenceMaps,
          [messageId]: referenceMap,
        },
      }))
    }

    if (!referenceMap[referenceId]) {
      const newReferenceIndex = Object.keys(referenceMap).length + 1

      set(state => ({
        referenceMaps: {
          ...state.referenceMaps,
          [messageId]: {
            ...referenceMap,
            [referenceId]: newReferenceIndex,
          },
        },
      }))

      return newReferenceIndex
    }

    return referenceMap[referenceId]
  },

  getReferenceMapByMessageId: (messageId: string) => get().referenceMaps[messageId],
}))

export const useReferenceMap = (messageId: string) =>
  useReferenceMaps(state => state.referenceMaps[messageId])

export const useAssignReferenceIndex = () =>
  useReferenceMaps(state => state.assignReferenceIndex)
